import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of, shareReplay } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loaderSubject = new BehaviorSubject<boolean>(false)
  loader$ = this.loaderSubject.asObservable();
  count: number = 0;
  private isLoading: boolean = false;

  constructor() { }

  start() {
    this.count++;
    this.loaderSubject.next(true);
    document.body.classList.add('loading_Bg');
  }

  stop() {
    setTimeout(() => {
      this.count--;
      if (this.count == 0) {
        const preloader = document.querySelector('.loader-bg');

        if (preloader === null) {
          return;
        }

        preloader.addEventListener('transitionend', (event: Event) => {
          if (event instanceof TransitionEvent && event.propertyName === 'opacity') {
            this.loaderSubject.next(false)
            preloader.remove();
            document.body.classList.remove('loading_Bg');
          }
        });
        preloader.classList.add('site-preloader__fade');
      }

    }, 10);
  }

  show(): void {
    this.isLoading = true;
  }

  hide(): void {
    this.isLoading = false;
  }

  getLoadingState(): boolean {
    return this.isLoading;
  }
}
